import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectCustomerData } from 'Core/redux/customer/selectors';
import {
  selectFilteredMoldReceiving,
  selectMoldReceivingFilterVisible,
  selectMoldReleaseLoading,
  selectfetchMoldReleaseLoading,
  selectMoldReceivingFilters,
} from './store/selectors';
import VirtualList from '../components/VirtualList'; // Import VirtualList
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner'; // Import LoadingSpinner
import { isHeaderVisible } from 'Core/redux/main/selectors';
import { Edit } from 'react-feather';
import { Button, ButtonGroup } from 'react-bootstrap';
import { editMoldReleaseData } from './store/slice';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { useTransformOptions } from '../../core/hooks';
import { PartService } from '../../service/api/part-service';

const MoldReleaseTile = props => {
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const [partsList, setPartsList] = useState([]);
  const moldReleaseTileRef = useRef(null);

  const filteredMoldReceiving = useSelector(selectFilteredMoldReceiving);
  const isLoading = useSelector(selectMoldReleaseLoading);
  const filterVisible = useSelector(selectMoldReceivingFilterVisible);
  const isFetchDataLoading = useSelector(selectfetchMoldReleaseLoading);
  const headerVisible = useSelector(isHeaderVisible);
  const filters = useSelector(selectMoldReceivingFilters);

  const updateColumnSettings = useCallback(() => {
    if (moldReleaseTileRef.current) {
      const width = moldReleaseTileRef.current.offsetWidth;
      let columns = 6;

      if (width < 576) {
        columns = 1; // Mobile
      } else if (width < 768) {
        columns = 3; // Tablets
      } else if (width < 992) {
        columns = 5; // Large screens
      } else {
        columns = 6; // Extra large screens
      }

      setColumnCount(columns);
      setColumnWidth(width / columns);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings]);

  useEffect(() => {
    const fetchParts = async () => {
      try {
        const response = await PartService.getAllPartsList();
        if (response?.response) {
          setPartsList(response.response);
        }
      } catch (error) {
        console.error('Error fetching parts list:', error);
      }
    };

    fetchParts();
  }, []);

  const Tile = ({ moldReceiving }) => {
  const dispatch = useDispatch();
  const customers = useSelector(selectCustomerData);
  const customerOptions = useTransformOptions(customers, 'id', 'customerName', '');
  const part = partsList.find(p => p.id === moldReceiving.partID);
  const partNumber = part?.partNumber || '';

  const handleEdit = e => {
    e.stopPropagation();
    // Get current status from the store
    const currentStatus = filters?.isReleased ?? 0; // Default to Released (0)
    dispatch(editMoldReleaseData({ moldReceiving, currentStatus }));
  };

  return (
    <div key={moldReceiving.id || Math.random()} className="tile">
      <div
        className={`card p-3 m-2 ${moldReceiving.isNewlyCreated ? 'border-success' : ''}`}
        style={{
          border: '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="tile-actions">
          <ButtonGroup size="sm">
            <Button variant="light" onClick={handleEdit}>
              <Edit size={16} />
            </Button>
          </ButtonGroup>
        </div>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <div className="ms-2 c-details">
              <h6 className="mb-0">{moldReceiving.toolID} </h6>
              <span>{moldReceiving.moldDescription}</span>
            </div>
          </div>
        </div>
        <div className="mt-1">
          <span
            className="badge"
            style={{
              backgroundColor: moldReceiving.backgroundColor || '#e0e0e0',
              color: moldReceiving.textColor || '#000000',
            }}
          >
            {partNumber}
          </span>
        </div>
        <div className="mt-2 tile-descriptionText text-truncate w-85">
          <h5 className="tile-description"> {moldReceiving.customerName}</h5>
        </div>
      </div>
    </div>
  );
};
  const itemData = filteredMoldReceiving.map(moldReceiving => (
    <Tile moldReceiving={moldReceiving} />
  ));
  
return (
    <div
      className={`tile-body ${filterVisible ? 'filter-visible' : ''} ${
        !headerVisible ? 'header-collapsed' : ''
      }`}
      ref={moldReleaseTileRef}
    >
      {(isLoading || isFetchDataLoading) && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={Math.ceil(filteredMoldReceiving.length / columnCount)}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={150} // Adjusted row height
        />
      }
    </div>
  );
};
const MySwal = withReactContent(Swal);

export default MoldReleaseTile;
